import { CurrencyDollarIcon } from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Customer Pipeline",
    href: "/sales/pipeline",
    icon: CurrencyDollarIcon,
    current: false,
    internalName: "customer_pipeline",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_SALES_MANAGER", "ROLE_SALES_REP"],
  },
];

const salesConfig = {
  sectionName: "sales",
  defaultRoute: "/sales/pipeline",
  navigation,
};

export default salesConfig;
